import "./styles/loggedOut.scss";

import React, { Component } from "react";
import { Redirect, Route, Switch } from "react-router-dom";

import courses from "./components/courseLanding/courses-json/coursesList.json";
import Loader from "../loader/loader";
const PrivacyPolicy = React.lazy(() => import("./components/privacyPolicy"));
const RemoveAccount = React.lazy(() =>
  import("../../../loggedOut/views/removeAccount")
);

const CourseLanding = React.lazy(() => import("./components/courseLanding"));
const ForgotPassword = React.lazy(() => import("./components/forgotPassword"));
const Landing = React.lazy(() => import("./components/landing"));
const RestoreFromLink = React.lazy(() =>
  import("./components/restoreFromLink")
);
const TermsConditions = React.lazy(() =>
  import("./components/termsConditions")
);
const LoggedOutHeader = React.lazy(() =>
  import("./components/landing/components/loggedOutHeader/loggedOutHeader")
);
const LoggedOutFooter = React.lazy(() =>
  import("./components/landing/components/loggedOutFooter/loggedOutFooter")
);
const Register = React.lazy(() => import("./components/register"));
const Login = React.lazy(() => import("./components/login"));
const ActivateThankYou = React.lazy(() => import("../user/activateThankYou"));

class LoggedOut extends Component {
  // TODO: refactor somehow
  componentDidMount() {
    this.saveUserID();
  }

  saveUserID() {
    const re = new RegExp("_ga=([^;]+)");
    const value = re.exec(document.cookie);
    const cookie = value != null ? unescape(value[1]) : null;
    const userId = cookie ? cookie.substring(6, cookie.length) : null;
    if (userId) {
      window.dataLayer.push({ user: "an-" + userId });
    }
  }

  render() {
    return (
      <div id="loggedOut" data-spy="scroll" data-offset="110">
        <LoggedOutHeader />
        <React.Suspense fallback={<Loader />}>
          <Switch>
            <Route exact path="/" component={Landing} />
            <Route exact path="/register" component={Register} />
            {/* {courses.map(course => <Route exact path={`/course/${course.courseUrl}`} key={shortid.generate()} render={()=> <CourseLanding course={course}/>} />)} */}
            <Route exact path="/login" component={Login} />
            <Route exact path="/forgot-password" component={ForgotPassword} />
            <Route exact path="/terms" component={TermsConditions} />
            <Route exact path="/remove-account" component={RemoveAccount} />
            <Route exact path="/privacy" component={PrivacyPolicy} />
            <Route
              exact
              path="/reset/:email/:hash"
              component={RestoreFromLink}
            />
            <Route
              exact
              path="/activate-email/:email/:hash"
              render={() => <ActivateThankYou isLoggedIn={false} />}
            />
            <Redirect from="*" to="/" />
          </Switch>
        </React.Suspense>
        {/* <LoggedOutFooter courses={courses} /> */}
        <LoggedOutFooter />
      </div>
    );
  }
}

export default LoggedOut;
